import React from "react";
import { ArrowRight, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="36943" id="hero-banner" className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden border-b border-[var(--border)] bg-background text-foreground" ref={ref}>
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1617553/img/macro_crystalline_powder_dropper.png)] bg-cover bg-center bg-no-repeat grayscale-[30%] opacity-40" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-[var(--background)]/95 via-[var(--background)]/80 to-[var(--background)]/95 backdrop-blur-[1px]" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[var(--background)]" />
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-6 text-center max-w-4xl">
        <div className={`transition-all duration-[800ms] ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
<h1 className="font-light tracking-widest text-[var(--foreground)] leading-[1.1] mb-6 font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl w-full max-w-4xl mx-auto">
  Daha Sağlıklı Dişler<br className="hidden sm:block" /> Daha Özgüvenli Bir Gülüş
</h1>
          {}
          <p className="text-lg md:text-[18px] text-[var(--muted-foreground)] mb-10 max-w-[600px] mx-auto leading-relaxed font-sans">Diş taşı temizliği, diş eti sağlığını korumanın ve ağız hijyenini sağlamanın en temel adımlarından biridir. Zamanla biriken plak ve tartarlar, profesyonel müdahale olmadan tamamen uzaklaştırılamaz ve diş eti hastalıklarına zemin hazırlayabilir.</p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild className="h-12 px-8 text-base font-medium rounded-[2px] bg-gradient-to-r from-[var(--primary)] to-[var(--chart-4)] text-[var(--primary-foreground)] hover:opacity-90 shadow-lg relative overflow-hidden group border-0">
              <Link to="https://wa.me/905535523234?text=Merhaba%20randevu%20almak%20istiyorum" newTab>
                <span className="relative z-10 flex items-center gap-2">
                  Randevu Al
                  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent opacity-50 pointer-events-none" />
              </Link>
            </Button>

            <Button asChild variant="outline" className="h-12 px-8 text-base font-medium rounded-[2px] border-[var(--border)] text-[var(--foreground)] hover:bg-[var(--secondary)] hover:text-[var(--foreground)] bg-transparent shadow-sm">
              <Link to="/TransformationGalleryPage">
                <span className="flex items-center gap-2">
                  Değişim Galerisi
                  <Search className="w-4 h-4" />
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}